import { EmailTemplateFormData } from "../types";
import {
  TemplateEditorLocaleObject,
  useEmailEditorLocale,
} from "../context/templates-editor-locale-context";
import { Block } from "@babackapp/blocks-editor/types";
import { isBlockTranslated } from "@babackapp/editor-blocks-library/blocks";

type TemplateValidationItem = {
  type: "missing_translation" | "missing_subject_translation";
  severity: "error" | "warning";
  blockId?: string;
};

export default function useTemplateValidation() {
  const { availableLocales, defaultLocale } = useEmailEditorLocale();

  function validateTemplate(templateData: EmailTemplateFormData) {
    const validationItems: TemplateValidationItem[] = [
      ...validateBlocksTranslation(
        templateData.content.beforeBlocks,
        availableLocales,
        defaultLocale,
      ),
      ...validateBlocksTranslation(
        templateData.content.insideBlocks,
        availableLocales,
        defaultLocale,
      ),
      ...validateBlocksTranslation(
        templateData.content.afterBlocks,
        availableLocales,
        defaultLocale,
      ),
    ];
    availableLocales.forEach((locale) => {
      if (!(templateData.subject[locale.value] as string)?.length) {
        validationItems.push({
          type: "missing_subject_translation",
          severity: locale.value === defaultLocale ? "error" : "warning",
        });
      }
    });

    return validationItems;
  }

  return {
    validateTemplate,
  };
}

function validateBlocksTranslation(
  blocks: Block[],
  availableLocales: TemplateEditorLocaleObject[],
  defaultLocale: string,
) {
  const validationItems: TemplateValidationItem[] = [];

  blocks.forEach((block) => {
    availableLocales.forEach((locale) => {
      if (!isBlockTranslated(locale.value, block)) {
        validationItems.push({
          type: "missing_translation",
          severity: locale.value === defaultLocale ? "error" : "warning",
          blockId: block.id,
        });
      }
    });
  });

  return validationItems;
}
